// extracted by mini-css-extract-plugin
export default {"nav":"PageTabs_nav__MNQfQ","text":"PageTabs_text__oqsY2","activeTab":"PageTabs_activeTab__4THrW","border":"PageTabs_border__S7bG1"};